import { AppRecord } from "../types"

export function filterInstalledApps(apps: AppRecord[] = []): AppRecord[] {
  return apps.filter((app) => app.is_installed)
}

export function filterUninstalledApps(apps: AppRecord[] = []): AppRecord[] {
  return apps.filter((app) => !app.is_installed)
}
